module.exports = __webpack_public_path__ + "img/ded-stock-card.e5a20e91.png";